import config from '@root/config'

export const INTEGRATION_WITH_FORM_KEYS = [
    'salesTraining',
    'beautyAutopilot',
    'crmSettings',
    'kpiSettings',
    'crmTO',
    // 'zvonoBot',
    'diagnostics',
    'webinars',
] as const

export type IntegrationWithFormKey = (typeof INTEGRATION_WITH_FORM_KEYS)[number]

export function getIntegrationWithFormIds(): string[] {
    return INTEGRATION_WITH_FORM_KEYS.map(
        (key) => config.marketplaceModulesIds[config.buildType][key],
    )
}

export function isPurchaseCountIntegration(
    integrationId: string | number | undefined | null,
): boolean {
    if (integrationId == null || integrationId === '') return false
    return getIntegrationWithFormIds().includes(String(integrationId))
}

export function getInstallCountNoun(
    integrationId: string | number | undefined | null,
): 'покупок' | 'установок' {
    return isPurchaseCountIntegration(integrationId) ? 'покупок' : 'установок'
}

export function getInstallCountQuantityLabel(
    integrationId: string | number | undefined | null,
): string {
    return isPurchaseCountIntegration(integrationId)
        ? 'Количество покупок'
        : 'Количество установок'
}

export function formatInstallCount(
    integration: { id?: string | number; installCount?: string | number | null } | undefined | null,
): string {
    const count = Number(integration?.installCount || 0).toLocaleString('ru-RU')
    return `${count} ${getInstallCountNoun(integration?.id)}`
}
